import styled from "styled-components";
import Header from "../Header";
import AboutWinax from "../AboutWinax"
import Niche from "../Niche";
import Testimonial from "../Testimonial";
import Team from "../Team";
import Footer from "../Footer";
import {useEffect} from 'react'


const About = () => {

    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
      
    return(
        <>
            <Header/>
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>About Us</h2>
                        <p>At winnthako we provide our clients with accessible,reliable and dependable financial services.Ranging from loans, investment and consulting .</p>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>
            <AboutWinax />
            <Niche/>
            <Testimonial/>
            <Team/>
            <Footer/>
        </>
    )
}

const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;

        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(45,3,3,1) 44%, rgba(0,212,255,1) 100%), url("/images/gallery/about1.jpg");
        background-size: cover;
        background-position-x: center;

        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;

    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`


export default About